<template>
	<div id="home-help" class="help">
		<div class="container">
			<div class="title headline-l">
				{{ title || $t('homeScreen.help.title') }}
			</div>
			<div v-if="description" class="description">
				{{ description }}
			</div>
			<base-button
				class="join-button"
				:text="buttonText || $t('homeScreen.help.buttonText')"
				size="large"
				type="light-green"
				@clicked="handleClick()"
			/>
		</div>
	</div>
</template>
  
<script>
import { mapGetters } from 'vuex';
export default {
	name: 'HomeHelp',
	props: {
		title: {
			type: String,
			default: null,
		},
		description: {
			type: String,
			default: null,
		},
		buttonText: {
			type: String,
			default: null,
		},
		customAction: {
			type: Function,
			default: null,
		},
	},
	components: {},
	data: () => ({}),
	created() {},
	computed: {
		...mapGetters({
			selectedLanguage: 'settings/getSelectedLanguage',
		}),
	},
	methods: {
		handleClick() {
			if (this.customAction) {
				this.customAction();
				return;
			}
			if (this.selectedLanguage == 'hu') {
				window.open(
					'https://data.blockben.com/FAQ/blockben_gyik.pdf',
					'_blank',
				);
			} else {
				window.open('https://data.blockben.com/FAQ/blockben_faq.pdf', '_blank');
			}
		},
	},
};
</script>
  
<style lang="scss" scoped>
#home-help {
	background-color: #e8e8ff;
	padding-top: 55px;
	padding-bottom: 70px;
	border-bottom: 1px solid #4b2eaa80;
	.container {
		text-align: center;
		padding: 0 15px;
	}
	.title {
		color: $black;
		margin-bottom: 40px;
		text-transform: uppercase;
	}
	.description {
		color: $black;
		font-size: 18px;
		line-height: 24px;
		margin-bottom: 40px;
		max-width: 750px;
		margin-left: auto;
		margin-right: auto;
	}
	.join-button {
		@media (max-width: $breakpoint-md) {
			width: 100%;
		}
	}
}
</style>
  